import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { EFilterCategories } from '@/constants/searchFilters';
import { getQueryParams } from '@/redux/selectors/queryParams';
import { EDeliveryOption } from '@/services/types/core/delivery.types';

interface IBringItToMeFilterItem {
  variation: EFilterCategories;
  active: boolean;
  count: number;
  onClick: () => void;
  selected: boolean;
  title: string;
}

export const useBringItToMeFilter = (
  onClick: () => void,
  selected: boolean,
): IBringItToMeFilterItem => {
  const intl = useIntl();
  const queryParams = useSelector(getQueryParams);

  const isActive =
    queryParams?.delivery === 'true' && queryParams?.deliveryStationary === EDeliveryOption.MOVING;

  return {
    variation: EFilterCategories.DELIVERY,
    active: isActive,
    count: 0,
    onClick,
    selected,
    title: intl.formatMessage({
      defaultMessage: 'Bring it to me',
      id: 'kuVIQh',
      description: 'Filter menu: Bring it to me option for rental mode',
    }),
  };
};
